const EmailStepPT = {
  EmailStep: {
    EMAIL: 'Email',
    LABEL_EMAIL: 'Digite seu email',
    VALIDATION: 'Email inválido',
    BUTTON_NEXT: 'Próximo',
    TITLE: 'Informe seu email para acessar e receber instruções da plataforma',
  },
};

const EmailStepEN = {
  EmailStep: {
    EMAIL: 'Email',
    LABEL_EMAIL: 'Type your email',
    VALIDATION: 'Invalid email',
    BUTTON_NEXT: 'Next',
    TITLE: 'What is your best email to access the platform and receive instructions?',
  },
};

export { EmailStepPT, EmailStepEN };
